export default __webpack_public_path__ + "3995c1b1bfdfc4c077503ae951d4ea4e.jpg";